import {Component, OnInit} from '@angular/core';
import {Shipment} from '../../../domain/shipment';
import {ActivatedRoute, NavigationEnd, Params, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Sort} from '@angular/material/sort';
import {CoreConfigurationService} from '../../../core-configuration.service';
import {PageEvent} from '@angular/material/paginator';

@Component({
    selector: 'app-deviated-shipment-list',
    templateUrl: './deviated-shipment-list.component.html',
    standalone: false
})
export class DeviatedShipmentListComponent implements OnInit {
  totalShipmentCount: number;
  shipments: Shipment[];
  currentPage = 0;
  currentSortBy: string;
  currentSortDirection: string;
  currentPageSize = 20;

  constructor(private route: ActivatedRoute, private router: Router, public coreConfiguration: CoreConfigurationService) {
  }

  ngOnInit() {
    this.initValue();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.initValue();
      });

    this.route.queryParams.subscribe((params: Params) => {
      if (params['page'] !== undefined) {
        this.currentPage = +params['page'] - 1;
      } else {
        this.currentPage = 0;
      }

      this.currentPageSize = params['pageSize'] == null ? 20 : params['pageSize'];
    });
  }

  private initValue() {
    this.totalShipmentCount = this.route.snapshot.data['data'].totalShipmentCount;
    this.shipments = this.route.snapshot.data['data'].shipments;
  }

  changePage(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.currentPageSize = event.pageSize;

    this.navigateWithNewParameters();
  }

  navigateWithNewParameters() {
    const params = {
      page: this.currentPage + 1,
      pageSize: this.currentPageSize,
      sortBy: this.currentSortBy,
      sortDirection: this.currentSortDirection
    };

    this.router.navigate(['/admin/shipments/deviated'], {queryParams: params});
  }

  sortChanged(sort: Sort) {
    this.currentSortBy = sort.active;
    this.currentSortDirection = sort.direction === 'desc' ? 'Desc' : 'Asc';

    this.navigateWithNewParameters();
  }

  showShipment(row: Shipment) {
    this.router.navigate(['/admin/shipment', row.Number]);
  }
}
